import { Tile, NUM_TILE_TYPES } from './tiles';
import { toCounts } from './hand';
import { isAgari } from './agari';

/** 13장 손패에 더하면 화료가 되는 타일들(오름차순). 텐파이 아니면 빈 배열. */
export function waits(concealed: readonly Tile[]): Tile[] {
  const counts = toCounts(concealed);
  const result: Tile[] = [];
  for (let t = 0; t < NUM_TILE_TYPES; t++) {
    if (counts[t] >= 4) continue; // 5번째는 존재할 수 없음
    counts[t]++;
    if (isAgari(counts)) result.push(t);
    counts[t]--;
  }
  return result;
}

export function isTenpai(concealed: readonly Tile[]): boolean {
  return waits(concealed).length > 0;
}

/** 대기패 중 하나라도 자신의 버림패에 있으면 후리텐. */
export function isFuriten(concealed: readonly Tile[], ownDiscards: readonly Tile[]): boolean {
  const w = new Set(waits(concealed));
  return ownDiscards.some((d) => w.has(d));
}
